import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=fcacda7a&scoped=true"
import script from "./effect.vue?vue&type=script&lang=js"
export * from "./effect.vue?vue&type=script&lang=js"
import style0 from "./effect.vue?vue&type=style&index=0&id=fcacda7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcacda7a",
  null
  
)

export default component.exports